/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/popover/custom-elements';

import { defineCustomElement as defineOsdsPopover } from '@ovhcloud/ods-stencil/components/popover/custom-elements/osds-popover.js';
import { defineCustomElement as defineOsdsPopoverContent } from '@ovhcloud/ods-stencil/components/popover/custom-elements/osds-popover-content.js';

export const OsdsPopover = /*@__PURE__*/createReactComponent<JSX.OsdsPopover, HTMLOsdsPopoverElement>('osds-popover', undefined, undefined, defineOsdsPopover);
export const OsdsPopoverContent = /*@__PURE__*/createReactComponent<JSX.OsdsPopoverContent, HTMLOsdsPopoverContentElement>('osds-popover-content', undefined, undefined, defineOsdsPopoverContent);
